import { V2NIMConst } from 'nim-web-sdk-ng'

const localOptions = {
  addFriendNeedVerify: true, // 添加好友模式，默认需要验证
  teamJoinMode: V2NIMConst.V2NIMTeamJoinMode.V2NIM_TEAM_JOIN_MODE_NEED_AUTH, // 加群需要验证
  teamAgreeMode: V2NIMConst.V2NIMTeamAgreeMode.V2NIM_TEAM_AGREE_MODE_NO_AUTH, // 同意入群需要审批 不需要 V2NIM_TEAM_AGREE_MODE_NEED_AUTH
  teamInviteMode: V2NIMConst.V2NIMTeamInviteMode.V2NIM_TEAM_INVITE_MODE_NEED_AUTH, // 邀请入群需要审批
  p2pMsgReceiptVisible: true, // 单聊消息是否显示已读未读 默认 false
  teamMsgReceiptVisible: true, // 群聊消息是否显示已读未读 默认 false
  needMention: true, // 是否需要@消息 默认 true
  loginStateVisible: true, // 是否显示在线离线状态 默认 true
  allowTransferTeamOwner: true, // 是否允许转让群主
  teamManagerVisible: true, // 是否需要显示群管理员相关主动功能，默认 false
  
  // 自定义邀请模式配置
  customInviteMode: {
    // 0: 所有人
    // 1: 群主和管理员
    // 2: 需要管理员或群主审核
    enableCustomInviteMode: true,
    inviteModeOptions: [
      { value: 0, label: '所有人' },
      { value: 1, label: '群主和管理员' },
      { value: 2, label: '需要管理员或群主审核' }
    ]
  }
}

export default localOptions
